module.exports = __webpack_public_path__ + "media/3c8c0d4eec4442c3c7b492bd2440fb1e.3c8c0d4e.mp4";